/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_CLASSIC_ORGANIZERS = `${ PREFIX_EVENTS_STORE }/SET_CLASSIC_ORGANIZERS`;
export const REMOVE_CLASSIC_ORGANIZERS = `${ PREFIX_EVENTS_STORE }/REMOVE_CLASSIC_ORGANIZERS`;
export const ADD_CLASSIC_ORGANIZERS = `${ PREFIX_EVENTS_STORE }/ADD_CLASSIC_ORGANIZERS`;

export const ADD_ORGANIZER_BLOCK = `${ PREFIX_EVENTS_STORE }/ADD_ORGANIZER_BLOCK`;
export const REMOVE_ORGANIZER_BLOCK = `${ PREFIX_EVENTS_STORE }/REMOVE_ORGANIZER_BLOCK`;
